import React from "react"
import {Modal} from "antd"
import {EditLDAPForm} from "./EditLDAPForm"
import {LDAPServerInfo} from "../../../models/ldap-server-info"

type Props = {
  visible: boolean
  onAdd: (ldapServerInfo: LDAPServerInfo) => void
  onClose: () => void
}

export const AddLDAPServerDialog: React.FC<Props> = ({
  visible,
  onAdd,
  onClose}): React.ReactElement =>
  <Modal
    title="Add LDAP Server"
    open={visible}
    onCancel={onClose}
    width={800}
    footer={null}>
    <EditLDAPForm
      onSubmit={(ldapServerInfo) => onAdd(ldapServerInfo)}
    />
  </Modal>